import { LangEnum } from '@/lang/enum';
import { useTranslation } from 'react-i18next';
import { useAppStore } from '@/store';

export default function useLang() {
  const { lang, setLang, setFwClass } = useAppStore();
  const { i18n } = useTranslation();

  const updateLanguage = (newLang: LangEnum) => {
    const targetLang = newLang || lang;

    document.getElementById('root')!.className = targetLang;
    document.body.className = targetLang;
    window.localStorage.setItem('i18nextLng', targetLang);
    setLang(targetLang);
    setFwClass(targetLang === LangEnum.EN ? 'en-fw' : 'zh-fw');
    window.dispatchEvent(new CustomEvent('boom-language-change'));

    if (targetLang) {
      i18n.changeLanguage(targetLang);
    }
  };

  return {
    updateLanguage,
  };
}
